export default "__VITE_ASSET__D7066ibA__"